import React from 'react';

const TrendsDashboard = () => {
  return (
    <div className="bg-white p-8 rounded-lg shadow text-center">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Dashboard de Tendências</h2>
      <p className="text-gray-600">Este dashboard está em desenvolvimento.</p>
      <p className="text-sm text-gray-500 mt-2">Em breve, novos indicadores e análises estarão disponíveis aqui.</p>
    </div>
  );
};

export default TrendsDashboard;